<template>
  <div>
    <div class="cyan">
      <div class="d-flex justify-space-between">
        <span class="text-subtitle-2 font-weight-bold pa-1 white--text">
          【お知らせ】キャッシュ機能により、設定を保存してから5分程度ホームページへの反映に時間が掛かかります。</span
        >
        <span>
          <a
            :href="props.com_data.site_url"
            target="previewSite"
            class="text-subtitle-2 pa-1 white--text font-weight-bold"
            >サイトを確認</a
          ></span
        >
      </div>
    </div>
    <v-tabs v-model="items" style="border-bottom: 1px solid lightgray">
      <v-tabs-slider></v-tabs-slider>
      <v-tab v-for="tab in tabs" :key="tab.index" class="font-weight-bold">{{
        tab.name
      }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="items" touchless>
      <v-tab-item v-for="tab in tabs" :key="tab.index">
        <component
          v-bind:is="tab.component"
          @tabmove="tabMove"
          :shop_site_id="props.com_data.id"
          :site_url="props.com_data.site_url"
        ></component>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { ref, reactive, onMounted, toRefs } from "@vue/composition-api";
import setting from "@/common/setting.js";
import PickupComponent from "./siteComponent/pickup.vue";
import WhatsNewComponent from "./siteComponent/whatsNew/index.vue";
import SiteSettingComponent from "./siteComponent/siteSetting.vue";
import PriceTableComponent from "./siteComponent/priceTable.vue";
import ShopInfoComponent from "./siteComponent/shopInfo.vue";
import RoomInfoComponent from "./siteComponent/roomInfo.vue";
import RecruitInfoComponent from "./siteComponent/recruitInfo.vue";
import ContactComponent from "./siteComponent/contact.vue";
import CustomCssComponent from "./siteComponent/customCss.vue";

export default {
  components: {
    PickupComponent,
    WhatsNewComponent,
    SiteSettingComponent,
    PriceTableComponent,
    ShopInfoComponent,
    RoomInfoComponent,
    RecruitInfoComponent,
    ContactComponent,
    CustomCssComponent,
  },
  props: ["com_data"],
  setup(props, ctx) {
    const items = ref();

    const tabs = [
      {
        index: 0,
        name: "新人・ピックアップ",
        component: PickupComponent,
      },
      {
        index: 1,
        name: "新着情報",
        component: WhatsNewComponent,
      },
      {
        index: 2,
        name: "基本設定",
        component: SiteSettingComponent,
      },
      {
        index: 3,
        name: "料金情報",
        component: PriceTableComponent,
      },
      {
        index: 4,
        name: "店舗情報",
        component: ShopInfoComponent,
      },
      {
        index: 5,
        name: "ルーム情報",
        component: RoomInfoComponent,
      },
      {
        index: 6,
        name: "求人情報",
        component: RecruitInfoComponent,
      },
      {
        index: 7,
        name: "フォーム設定",
        component: ContactComponent,
      },
      {
        index: 8,
        name: "カスタムCSS",
        component: CustomCssComponent,
      },
    ];

    const tabMove = (tabIndex) => {
      items.value = tabIndex;
    };

    return {
      setting,
      items,
      tabs,
      props,
      tabMove,
    };
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: #e8f5e9;
}
</style>
